export function playbackFrameVisible(displayedId: string | null, pendingId: string | null) {
  return pendingId == null || pendingId === displayedId;
}

export function shouldAdvancePlaybackClock(playing: boolean, frameVisible: boolean) {
  return playing && frameVisible;
}

export function showPlayerLoadingChrome(liveFollow: boolean, frameVisible: boolean) {
  return !liveFollow && !frameVisible;
}

export function keepWaitingPaneForFirstLivePaint(
  liveFollow: boolean,
  displayedId: string | null,
  pendingId: string | null,
) {
  return liveFollow && pendingId != null && displayedId == null;
}

export function playerFrameNeedsPaint(
  displayed: { id: string; url: string } | null,
  pendingId: string | null,
  pendingUrl: string | null,
) {
  return pendingId != null && pendingUrl != null && (displayed?.id !== pendingId || displayed.url !== pendingUrl);
}
